<template>
    <div class="home-box">
      <div>
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">商户余额提现记录</span>
        </div>
        <el-divider />
      </div>

      <!-- 查询区域 -->
      <div class="top-query">
        <div class="top-query-left">
          <!-- <div class="demo-input-suffix">
            审核状态：
            <el-select v-model="value1" placeholder="请选择" clearable >
                <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
          </div> -->
          <div class="demo-input-suffix">
            商家名称：
            <el-select v-model="query.storeid" filterable clearable placeholder="请输入商家名称">
              <el-option
                v-for="item in storeOptions"
                :key="item.id"
                :label="item.storename"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            日期：
            <el-date-picker
              v-model="query.datePick"
              align=“center”
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              @change="dateChange">
            </el-date-picker>
          </div>
          <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
          <el-button @click="download" type="success" icon="el-icon-printer">导出</el-button>
        </div>
  
        <div class="top-query-right"></div>
      </div>
  
      <!-- table区域-begin -->
      <div class="table-box">
        <el-table :data="tableData.data" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column prop="amount" label="余额" min-width="80">
          </el-table-column>
          <el-table-column prop="withdraw_id" label="订单ID" min-width="120">
          </el-table-column>
          <el-table-column prop="settle_account" label="提现账号" min-width="120">
          </el-table-column>
          <el-table-column prop="withdraw_msg" label="提现备注" min-width="120">
          </el-table-column>
          <el-table-column prop="storename" label="商家名称" min-width="120">
          </el-table-column>
          <el-table-column prop="withdraw_time" label="创建时间" min-width="120">
          </el-table-column>
        </el-table>
      </div>
      <!-- table区域-end -->
  
      <!-- 分页区域-begin -->
      <div>
        <el-pagination
          class="pagination"
          background layout="prev, pager, next"
          :total="tableData.total"
          :page-size="tableData.per_page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <!-- 分页区域-end -->
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations } from "vuex";
  
  export default({
  // export default Vue.extend({
    name: "businessCashOut",
    data() {
      return {
        query: {
          storeid: "",
          datePick: '',
          startdate: '',
          enddate: '',
        },
        input1: "",
        tableData: [],
        options1: [{
            value: '选项1',
            label: '待审核'
        }, {
            value: '选项2',
            label: '审核通过'
        }, {
            value: '选项3',
            label: '审核被拒'
        }],
        value1: '',
        storeOptions: [],
        total: 100,
        loading: false,
        page: 1,
      };
    },
    computed: {
      ...mapState(["user", "setting"]),
    },
    mounted() {
      let user = JSON.parse(localStorage.user);
      this.token = user.token;

      this.getStoreOption()
      this.getWithdrawList()
    },
    methods: {
      ...mapMutations(["setuser", "setsetting"]),
      // 日期选择
      dateChange(e) {
        console.log('e', e)
        this.query.startdate = e?e[0]:''
        this.query.enddate = e?e[1]:''
      },
      search() {
        console.log('查询', this.query);
        let data = {
          ...this.query,
          page: this.page,
        }
        this.getWithdrawList(data)
      },
      add() {
        console.log('新增');
      },
      handleDetails() {
        console.log('详情');
      },
      handleEdit() {
        console.log('编辑');
      },
      handleDelete() {
        console.log('删除');
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val
        this.search()
      },
      // 获取提现列表
      getWithdrawList(data) {
        this.loading = true
        this.$api.getWithdrawList({...data}).then(
          res => {
            if(res.code == 'success'){
              this.tableData = res.data
            }else{
              this.$message.error(res.msg)
            }
            this.loading = false
          }
        ).catch(err=>{
          this.$message.error(err.msg)
          this.loading = false
        })
      },
      // 商家列表
      getStoreOption() {
        this.loading = true
        // 0：有分页，1：无分页数据
        this.$api.getStoreList({type_limit:1}).then(
          res => {
            if(res.code == 'success'){
              this.storeOptions = res.data
            }else{
              this.$message.error(res.msg)
            }
            this.loading = false
          }
        ).catch(err=>{
          this.$message.error(err.msg)
          this.loading = false
        })
      },
      // 导出
      download() {
        let data = {
          ...this.query,
          page: this.page,
          limit: that.tableData.total>500?that.tableData.total:500,
        }
        this.$api.getWithdrawList(data).then(
          res => {
            if(res.code == 'success'){
              require.ensure([], () => {
                const { export_json_to_excel } = require('../excel/export2Excel.js')
                const tHeader = ['ID', '余额', '订单ID', '提现账号', '提现备注', '商家名称', '创建时间']
                const filterVal = ['id', 'amount', 'withdraw_id', 'settle_account', 'withdraw_msg', 'storename', 'withdraw_time']
                const list = res.data.data
                const data = this.formatJson(filterVal, list)
                        export_json_to_excel(tHeader, data, '商户余额提现记录')
                    })
            }else{
              this.$message.error(res.msg)
            }
          }
        ).catch(err=>{
          this.$message.error(err.msg)
        })
        return
        let res = this.tableData.data
        require.ensure([], () => {
        const { export_json_to_excel } = require('../excel/export2Excel.js')
        const tHeader = ['ID', '余额', '订单ID', '提现账号', '提现备注', '商家名称', '创建时间']
        const filterVal = ['id', 'amount', 'withdraw_id', 'settle_account', 'withdraw_msg', 'storename', 'withdraw_time']
        const list = res
        const data = this.formatJson(filterVal, list)
                export_json_to_excel(tHeader, data, '商户余额提现记录')
            })
      },
      // 导出
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      }
    },
  });
  </script>
  
  <style scoped lang="less">
  @import "../assets/less/easyElement.less";
  </style>
  